import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener('blur', event => {
      const numVal = Number(this.element.value.replace(/,/g, ""));
      if (numVal) {
        this.element.value = numVal.toLocaleString("ja-JP");
      }
    })
  }
}
